import { Controller } from "@hotwired/stimulus";
import {
  formatJapanesePhoneNumber,
  sanitizePhoneDigits,
} from "../utils/format_japanese_phone_number";

export default class extends Controller {
  static targets = ["tel", "fax"];

  connect() {
    if (this.hasTelTarget && this.telTarget.value) {
      this.validateAndFormatField(this.telTarget);
    }

    if (this.hasFaxTarget && this.faxTarget.value) {
      this.validateAndFormatField(this.faxTarget);
    }
  }

  validateAndFormatTel(event) {
    const field = event.target;

    if (field === this.telTarget) {
      this.validateAndFormatField(this.telTarget);
    } else if (field === this.faxTarget) {
      this.validateAndFormatField(this.faxTarget);
    }
  }

  validateAndFormatField(field) {
    const sanitizedInput = sanitizePhoneDigits(field.value);

    field.setCustomValidity("");
    field.value = formatJapanesePhoneNumber(sanitizedInput);
  }
}
